import { CreateElement, VNode } from 'vue'
import { H1, H2, H3, H4, H5, H6, Body1, Body2, Subtitle1, Subtitle2, Caption, Overline } from '@src/elements/typography/typography'

export function renderTypography (h: CreateElement): VNode[] {
  return [
    <H1 ref='h1'>H1</H1>,
    <H2 ref='h2'>H2</H2>,
    <H3 ref='h3'>H3</H3>,
    <H4 ref='h4'>H4</H4>,
    <H5 ref='h5'>H5</H5>,
    <H6 ref='h6'>H6</H6>,

    <Body1 ref='body-1'>Body 1</Body1>,
    <Body2 ref='body-2'>Body 2</Body2>,

    <Subtitle1 ref='subtitle-1'>Subtitle 1</Subtitle1>,
    <Subtitle2 ref='subtitle-2'>Subtitle 2</Subtitle2>,

    <Caption ref='caption'>Caption</Caption>,

    <Overline ref='caption'>Overline</Overline>
  ]
}
